import { __assign, __spreadArray } from "tslib";
import * as React from 'react';
import { Tag, SuggestionList } from '../../components/index.js';
import { useSuggestionList } from '../../hooks/index.js';
function defaultDisplay(value) {
    return React.createElement(React.Fragment, null, value);
}
function defaultCheck(tag, value) {
    var current = tag.toLowerCase();
    return !value.find(function (tag) { return tag.toLowerCase() === current; });
}
export var TagInput = function (_a) {
    var error = _a.error, onChange = _a.onChange, defaultValue = _a.defaultValue, _b = _a.value, value = _b === void 0 ? [] : _b, _c = _a.maxTags, maxTags = _c === void 0 ? Number.MAX_SAFE_INTEGER : _c, label = _a.label, disabled = _a.disabled, onSuggest = _a.onSuggest, _d = _a.onDisplay, onDisplay = _d === void 0 ? defaultDisplay : _d, _e = _a.onCheck, onCheck = _e === void 0 ? defaultCheck : _e, children = _a.children;
    var _f = React.useState(''), suffix = _f[0], setSuffix = _f[1];
    var _g = React.useState(defaultValue), tags = _g[0], setTags = _g[1];
    var _h = useSuggestionList(), el = _h[0], suggestionsInfos = _h[1], setSuggestionsInfos = _h[2], loadSuggestions = _h[3];
    var input = React.useRef(undefined);
    var managed = React.useMemo(function () { return defaultValue !== undefined; }, []);
    var chosenTags = managed ? tags : value;
    var noInput = disabled || chosenTags.length >= maxTags;
    var inputChanged = React.useCallback(function () {
        var search = input.current.textContent;
        if (typeof onSuggest === 'function') {
            var results = onSuggest === null || onSuggest === void 0 ? void 0 : onSuggest(search);
            loadSuggestions(results);
        }
    }, [onSuggest]);
    var keyboardNavigation = function (ev) {
        var key = ev.key;
        var useEntry = key === 'Enter' || key === ',' || key === ';' || key === 'Tab';
        var search = input.current.textContent;
        if (noInput) {
            if (key === 'Backspace') {
                removeTag(chosenTags.length - 1);
            }
            ev.preventDefault();
        }
        else {
            if (useEntry && suggestionsInfos.cursor !== -1) {
                var suggestion = suggestionsInfos.suggestions[suggestionsInfos.cursor];
                addTag(typeof suggestion === 'string' ? suggestion : suggestion.value);
                ev.preventDefault();
            }
            else if (key === 'ArrowDown' || key === 'ArrowUp') {
                var len = suggestionsInfos.suggestions.length;
                if (len > 0) {
                    var delta = suggestionsInfos.isVisible ? (key === 'ArrowDown' ? +1 : -1) : 0;
                    var cursor_1 = (suggestionsInfos.cursor + delta + len) % len;
                    setSuggestionsInfos(function (data) { return (__assign(__assign({}, data), { cursor: cursor_1, isVisible: true })); });
                }
                ev.preventDefault();
            }
            else if (key === 'Escape') {
                setSuggestionsInfos(function (data) { return (__assign(__assign({}, data), { isVisible: false })); });
                ev.preventDefault();
            }
            else if (useEntry && search && suggestionsInfos.cursor === -1) {
                addTag(search);
                ev.preventDefault();
            }
            else if (key === 'Backspace' && !search) {
                removeTag(chosenTags.length - 1);
                ev.preventDefault();
            }
        }
    };
    var updateSuffix = React.useCallback(function () {
        var currentTarget = input.current;
        var search = currentTarget.textContent;
        var invalid = !!search && currentTarget !== document.activeElement;
        var inFocus = currentTarget === document.activeElement;
        setSuffix("".concat(search || inFocus ? ' active' : '').concat(error || invalid ? ' error' : ''));
    }, [error]);
    React.useEffect(updateSuffix, [error]);
    var changeTags = React.useCallback(function (newTags) {
        if (managed) {
            setTags(newTags);
        }
        input.current.textContent = '';
        setSuggestionsInfos(function (data) { return (__assign(__assign({}, data), { cursor: -1, isVisible: false })); });
        updateSuffix();
        onChange === null || onChange === void 0 ? void 0 : onChange(newTags);
    }, [onChange, updateSuffix]);
    var removeTag = React.useCallback(function (i) { return changeTags(chosenTags.filter(function (_, j) { return i !== j; })); }, [chosenTags, changeTags]);
    var addTag = React.useCallback(function (value) {
        var canAdd = typeof onCheck === 'function' ? onCheck(value, chosenTags) : undefined;
        if (canAdd !== null && canAdd !== void 0 ? canAdd : true) {
            changeTags(__spreadArray(__spreadArray([], chosenTags, true), [value], false));
        }
    }, [chosenTags, changeTags]);
    var onInput = noInput ? undefined : inputChanged;
    var onFocus = noInput ? undefined : updateSuffix;
    return (React.createElement("div", { className: "form-group", ref: el },
        React.createElement("div", { className: "input-tag__container".concat(suffix), disabled: disabled },
            React.createElement("div", { className: "input-tag" },
                React.createElement("ul", { className: "input-tag__tags" },
                    chosenTags.map(function (tag, i) { return (React.createElement("li", { key: tag },
                        React.createElement(Tag, { label: onDisplay(tag) },
                            React.createElement("button", { type: "button", onClick: function () { return removeTag(i); }, disabled: disabled }, "+")))); }),
                    React.createElement("li", { className: "input-tag__tags__input", style: { visibility: noInput ? 'hidden' : 'visible' } },
                        React.createElement("span", { ref: input, className: "tag-label", contentEditable: true, onInput: onInput, onChange: onInput, onKeyDown: keyboardNavigation, onFocus: onFocus, onBlur: onFocus })))),
            label && React.createElement("label", { className: "text-floating".concat(suffix) }, label)),
        children,
        React.createElement(SuggestionList, { onSelect: addTag, loading: suggestionsInfos.loading, visible: suggestionsInfos.isVisible, suggestions: suggestionsInfos.suggestions, cursor: suggestionsInfos.cursor })));
};
//# sourceMappingURL=index.js.map